import Switch from './atoms/Switch';
import Input from './atoms/Input';
import Button from './atoms/Button';

interface CreateEditInPersonProps {
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
}

const CreateEditInPerson: React.FC<CreateEditInPersonProps> = ({ handleSubmit, onCancel }) => (
  <div>
    <form className='flex flex-col gap-4' onSubmit={handleSubmit}>
      <Switch label='Caja habilitada para la venta' />
      <Input id='name' label='Nombre de la caja' labelAbove name='name' />
      <Input id='amount' label='Cantidad inicial' labelAbove name='amount' />
      <Input id='total' label='Total vendido' labelAbove name='total' />
      <Input id='transactions' label='Movimientos' labelAbove name='transactions' />
      <Input id='balance' label='Balance' labelAbove name='balance' />
      <div className='flex flex-row gap-2'>
        <Button variant='secondary' onClick={onCancel}>Cancelar</Button>
        <Button variant='primary' type='submit'>Guardar</Button>
      </div>
    </form></div>);

export default CreateEditInPerson;
